<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col-md-12">
        <pr-panel></pr-panel>
        <div class="man pr-panel">
          <pr-panel-body>
            <div class="pr-panel-body undefined">
              <div
                class="pr-card-swiper animated fadeIn relative overflow-hidden"
              >
                <table class="pr-table-card-container" style="width: 100%">
                  <tbody class="pr-table-card-statistics-body">
                    <ng-container>
                      <div class="pr-table-card-row ng-star-inserted">
                        <div class="pointer pr-table-card-row-container">
                          <div
                            class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                          >
                            <div
                              class="d-flex ng-star-inserted flex-column"
                              style="max-width: 500px"
                            >
                              <span class="ng-star-inserted text-ellipsis"
                                >Patrimoine constitué personnellement</span
                              >
                              <small class="ng-star-inserted">
                                (Salaire, revenus immobiliers, revenus
                                professionnels, ...)</small
                              >
                            </div>
                          </div>

                          <div
                            class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                          >
                            <div
                              class="d-flex ng-star-inserted"
                              style="max-width: 300px"
                              [formGroup]="form.get('personally')"
                            >
                              <span class="ng-star-inserted">
                                <input
                                  notdot
                                  class="full-w percent"
                                  formControlName="percent"
                                /> </span
                              ><span
                                style="margin-left: 3px"
                                class="ng-star-inserted"
                                >%</span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="pointer pr-table-card-row-container">
                          <div
                            class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                          >
                            <div
                              class="d-flex ng-star-inserted flex-column"
                              style="max-width: 500px"
                            >
                              <span class="ng-star-inserted text-ellipsis"
                                >Patrimoine familial</span
                              >
                              <small class="ng-star-inserted">
                                (Donation, héritage, ...)</small
                              >
                            </div>
                          </div>

                          <div
                            class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                          >
                            <div
                              class="d-flex ng-star-inserted"
                              style="max-width: 300px"
                              [formGroup]="form.get('family')"
                            >
                              <span class="ng-star-inserted">
                                <input
                                  notdot
                                  class="full-w percent"
                                  formControlName="percent"
                                /> </span
                              ><span
                                style="margin-left: 3px"
                                class="ng-star-inserted"
                                >%</span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="pointer pr-table-card-row-container">
                          <div
                            class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                          >
                            <div
                              class="d-flex ng-star-inserted"
                              style="max-width: 500px"
                            >
                              <span
                                class="ng-star-inserted flex-column text-ellipsis"
                                >Patrimoine de société, de groupement ou
                                d'association</span
                              >
                              <small class="ng-star-inserted">
                                (Dividendes, remboursement de compte courant
                                associé, ...)</small
                              >
                            </div>
                          </div>

                          <div
                            class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                          >
                            <div
                              class="d-flex ng-star-inserted"
                              style="max-width: 300px"
                              [formGroup]="
                                form.get('companyOrGroupOrAssociation')
                              "
                            >
                              <span class="ng-star-inserted">
                                <input
                                  notdot
                                  class="full-w percent"
                                  formControlName="percent"
                                /> </span
                              ><span
                                style="margin-left: 3px"
                                class="ng-star-inserted"
                                >%</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </pr-panel-body>
        </div>
      </div>
    </div>
    <div class="row mt">
      <div class="col-md-12">
        <pr-color-panel [display]="allocationPanel.display">
          <pr-panel-body clazz="pam">
            <pr-label
              [name]="allocationPanel.icon"
              [width]="18"
              [height]="18"
              >{{ allocationPanel.text }}</pr-label
            >
          </pr-panel-body>
        </pr-color-panel>
      </div>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
